<script lang="ts">
	import InputRadios from '$lib/elements/inputs/variants/InputRadios.svelte';
	import { findPropsByApiKey } from '@app/utils/kyc';
	import { t } from 'svelte-i18n';
	export let props;

	$: isPpeProps = findPropsByApiKey(props.questions, 'ppe');
	$: ppeProfessionProps = findPropsByApiKey(props.questions, 'ppeFonctionExercee');
	$: ppeCountryProps = findPropsByApiKey(props.questions, 'ppePaysExercice');

	$: isPpe =
		props?.value === 'MOI_MEME' || props?.value === 'MEMBRE_FAMILLE_OU_PROCHE' ? 'true' : 'false';
	$: isPpeProps.value = new Boolean(isPpe === 'true').toString();

	$: if (isPpe === 'false') {
		ppeProfessionProps.value = undefined;
		ppeCountryProps.value = undefined;
		isPpeProps.value = isPpe;
	}
	$: {
		ppeProfessionProps.required = isPpe;
		ppeCountryProps.required = isPpe;
	}
</script>

<div class={`space-4 text-left`}>
	{#if props}
		<InputRadios bind:props />

		{#if props.questions && isPpe === 'true'}
			<div class="pt-5">
				{#each props.questions as question, i (i)}
					<div class="mb-2">
						<svelte:component this={question.component} bind:props={question.props} {i} />
					</div>
				{/each}
				<p class="mt-4">{@html $t('kyc.inputs.isPPE.hint')}</p>
			</div>
		{/if}
	{/if}
</div>
